import { Component } from '@angular/core'
import { MeasurementController } from '@classes/MeasurementController'
import { Activity, EnvironmentManagerService } from '@services/environment-manager.service'
import { NavPopupService } from '@services/nav-popup.service'

@Component({
  selector: 'shared-measurement-btn',
  templateUrl: './measurement-btn.component.html',
  styleUrls: ['./measurement-btn.component.css'],
  standalone: false
})
export class MeasurementBtnComponent {
  get enabled(): boolean { return this.measurementController?.enabled }
  get measurementController(): MeasurementController { return this.envManager?.measurementController }
  get units(): string { return this.envManager?.measurementController?.units }
  get state(): string { return this.envManager?.measurementController.state }
  get hasMeasurements(): boolean { return this.measurementController?.hasMeasurements() || false }
  get isNavPopupOpen$() { return this._navPopupService.isOpen$ }
  public showMeasurementUI: boolean = false

  constructor(
    public envManager: EnvironmentManagerService,
    private _navPopupService: NavPopupService
  ) { }

  toggleMeasurementMode() {
    if (this.envManager.isMeasuring) {
      this.envManager.currentActivity = Activity.Editing
      this.showMeasurementUI = false
    } else {
      this.envManager.currentActivity = Activity.Measuring
      this.showMeasurementUI = true
    }
  }

  toggleMeasuring() {
    if (this.measurementController.state == 'measureMode') {
      this.measurementController.enableMeasuring()
    } else {
      this.measurementController.finishMeasuring()
    }
  }

  convertUnit(newUnit: "m" | "ft" | "mi" | "km") {
    this.envManager.measurementController.changeUnit(newUnit)
  }

  clearAllMeasurements() {
    this.measurementController.clearAllMeasurements()
  }
}